// src/app/equipment.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Equipment } from '../objects/Equipment';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EquipmentService { 
  private apiUrl = environment.apiUrl +'Equipments'; // Replace with your API endpoint

  constructor(private http: HttpClient) {}

  getEquipment(): Observable<Equipment[]> {
    return this.http.get<Equipment[]>(this.apiUrl);
  }

  getEquipmentById(id: number): Observable<Equipment> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.get<Equipment>(url);
  }

  addEquipment(equipment: Equipment): Observable<Equipment> {
    return this.http.post<Equipment>(this.apiUrl, equipment);
  }

  editEquipment(equipment: Equipment): Observable<Equipment> {
    const url = `${this.apiUrl}/${equipment.id}`;
    return this.http.put<Equipment>(url, equipment);
  }
}
